import robotWidget from "../assets/chatbot/robot-widget.png";

const ChatbotWidget = ({ onToggle }) => {
  return (
    <button
      onClick={onToggle}
      className="relative"
      style={{
        width: "103px",
        height: "80.07px",
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: "pointer",
      }}
    >
      <img
        src={robotWidget}
        alt="Chat with Omni"
        className="object-contain w-full h-full"
        style={{
          filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.25))",
        }}
      />
    </button>
  );
};

export default ChatbotWidget;
